import { render, staticRenderFns } from "./BandeauInformation.vue?vue&type=template&id=45ba25da"
import script from "./BandeauInformation.vue?vue&type=script&lang=ts"
export * from "./BandeauInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports